

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

@Component({
	components: {
	}
})
export default class LightDarkSwitch extends Vue {
	@Getter getDarkMode!: boolean;
	@Action setTheme!: (darkMode: boolean) => void;

	get isDark () {
		return this.getDarkMode
	}

	set isDark (value: boolean) {
		this.setTheme(value)
	}

	updateTheme () {
		this.setTheme(this.isDark)
	}
}
